// extracted by mini-css-extract-plugin
module.exports = {"blogDetail":"detail_page_blogDetail__1vHxt","info":"detail_page_info__3bI0s"};